var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiChannelNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_2991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 15.9999V15.8666C6.66634 14.7465 6.66634 14.1864 6.88433 13.7586C7.07607 13.3823 7.38204 13.0763 7.75836 12.8846C8.18618 12.6666 8.74624 12.6666 9.86634 12.6666H14.133C15.2531 12.6666 15.8132 12.6666 16.241 12.8846C16.6173 13.0763 16.9233 13.3823 17.115 13.7586C17.333 14.1864 17.333 14.7465 17.333 15.8666V15.9999M6.66634 15.9999C5.92996 15.9999 5.33301 16.5969 5.33301 17.3333C5.33301 18.0696 5.92996 18.6666 6.66634 18.6666C7.40272 18.6666 7.99967 18.0696 7.99967 17.3333C7.99967 16.5969 7.40272 15.9999 6.66634 15.9999ZM17.333 15.9999C16.5966 15.9999 15.9997 16.5969 15.9997 17.3333C15.9997 18.0696 16.5966 18.6666 17.333 18.6666C18.0694 18.6666 18.6663 18.0696 18.6663 17.3333C18.6663 16.5969 18.0694 15.9999 17.333 15.9999ZM11.9997 15.9999C11.2633 15.9999 10.6663 16.5969 10.6663 17.3333C10.6663 18.0696 11.2633 18.6666 11.9997 18.6666C12.7361 18.6666 13.333 18.0696 13.333 17.3333C13.333 16.5969 12.7361 15.9999 11.9997 15.9999ZM11.9997 15.9999V9.33325M7.99967 9.33325H15.9997C16.6209 9.33325 16.9316 9.33325 17.1766 9.23176C17.5033 9.09643 17.7629 8.83687 17.8982 8.51016C17.9997 8.26514 17.9997 7.95451 17.9997 7.33325C17.9997 6.712 17.9997 6.40137 17.8982 6.15634C17.7629 5.82964 17.5033 5.57007 17.1766 5.43475C16.9316 5.33325 16.6209 5.33325 15.9997 5.33325H7.99967C7.37842 5.33325 7.06779 5.33325 6.82276 5.43475C6.49606 5.57007 6.23649 5.82964 6.10117 6.15634C5.99967 6.40137 5.99967 6.712 5.99967 7.33325C5.99967 7.95451 5.99967 8.26514 6.10117 8.51016C6.23649 8.83687 6.49606 9.09643 6.82276 9.23176C7.06779 9.33325 7.37842 9.33325 7.99967 9.33325Z",
    stroke: "#FFF4F0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_2991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiChannelNodeIcon);
export default __webpack_public_path__ + "static/media/multiChannelNodeIcon.924bc9879543499a15628e59d46af2b1.svg";
export { ForwardRef as ReactComponent };